import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ToggleSmall, Search } from 'carbon-components-react';
import _ from 'lodash';
import mainActions from '../redux/modules/main';
import Accordion from './Accordion';
import { getDmService } from '../services/Api';
import { AGENCIA, COMUNICACAO } from '../config/turnOnOff';
import { Administrador, Criacao, GerenteComercial, Comunicacao, TradeAdm } from '../config/UserStatusLevel';

const Link = ({ to, className, children, ...props }) => {
  const classNames = ['nav-item', className].join(' ');
  return (
    <NavLink
      to={to}
      /* onClick={() => this.closeMenuOnSmallScreen()} */
      className={classNames}
      activeClassName="nav-item--actived"
      exact
      {...props}
    >
      {children}
    </NavLink>
  );
};

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: JSON.parse(localStorage.getItem('user')) || { nivel: {} },
      // eslint-disable-next-line react/no-unused-state
      categorias: [],
      groups: [],
      filterGroups: [],
      products: [],
      filterProducts: []
    };
  }

  componentWillMount() {
    const { user } = this.state;
    const { toggleAdminMenu, showAdminMenu, loadBadgets } = this.props;
    const showAdminMenuStoraged = localStorage.getItem('showAdminMenu');
    if (user.nivel.id === Administrador && !showAdminMenuStoraged) {
      toggleAdminMenu();
    } else if (user.nivel.id !== Administrador && showAdminMenu) {
      toggleAdminMenu();
    }

    this.getCategoriasBrinde();
    this.getGroupsAgency();
    loadBadgets();
  }

  componentDidMount() {
    // Se já tem tamanho pequeno tira o menu
    this.closeMenuOnSmallScreen();
    // Se não, cuida o resize
    this.listenForResize();
  }

  getPermission = async () => {
    const { user: userObj } = this.state;
    const permission =
      (await userObj) && userObj.nivel ? userObj.nivel.id : null;
    return permission;
  };

  getCategoriasBrinde = async () => {
    const permission = await this.getPermission();
    const isDesigner = permission && permission !== Criacao;
    const isGerenteComercial = permission && permission !== GerenteComercial;
    if (isDesigner && isGerenteComercial) {
      try {
        const categorias = await getDmService(
          '/ProdutoCategoria/GetMenuByTipo/?tipo=2'
        );

        const arrayCategorias = [];
        categorias.map(categ =>
          arrayCategorias.push({ categoria: categ.nome, id: categ.id })
        );

        this.setState({
          // eslint-disable-next-line react/no-unused-state
          categorias: arrayCategorias
        });
      } catch (ex) {
        console.log('falha ao carregar as categorias de brind');
      }
    }
  };

  getGroupsAgency = async () => {
    const permission = await this.getPermission();
    const isDesigner = permission && permission !== Criacao;
    const isGerenteComercial = permission && permission !== GerenteComercial;

    if (isDesigner && isGerenteComercial) {
      try {
        const groups = await getDmService('/ProdutoCategoria/GetMenuByTipo/?tipo=1');
        let arrayGroups = groups.map(item => ({
          id: item.id,
          group: item.nome
        }));
        // exclusivo kit merchan
        arrayGroups = arrayGroups.filter(x => x.group !== "Kit Merchan P" && x.group !== "Kit Merchan M" && x.group !== "Kit Merchan G");

        const products = await getDmService(`/Pedido/GetNomeProduto/?mostraAtivos=true`);
        let arrayProducts = products.map(product => ({
          id: product.id,
          label: product.nome,
          descricao: product.descricao,
          groupId: product.grupo_Id,
          groupNome: product.grupo_Nome
        }));
        // exclusivo kit merchan
        arrayProducts = arrayProducts.filter(x => x.groupNome !== "Kit Merchan P" && x.groupNome !== "Kit Merchan M" && x.groupNome !== "Kit Merchan G");

        this.setState({
          groups: arrayGroups,
          products: arrayProducts
        });
      } catch (ex) {
        console.log(ex);
      }
    }
  };

  isCurrentRoute = to => {
    const { location } = this.props;
    return _.includes(location.pathname, to);
  };

  toggleMenu = () => {
    const { history, toggleAdminMenu } = this.props;
    toggleAdminMenu();
    history.push('/');
  };

  renderHeaderComponent = (title, isExpanded, badgets, showBadget) => (
    <div
      className={`nav-items-header ${isExpanded &&
        'nav-items-header--actived'}`}
    >
      {title}
      {!!badgets && !!showBadget && badgets > 0 && (<span className="badget">{badgets}</span>)}
    </div>
  );

  renderItemHeaderComponent = (title, isExpanded) => (
    <div
      className={`nav-item-select bold-uppercase-item ${isExpanded &&
        'nav-items-header--actived'}`}
    >
      {title}
    </div>
  );

  closeMenuOnSmallScreen = () => {
    const currentPath = window.location.pathname;
    const widthScreen = window.innerWidth;

    switch (currentPath) {
      case "/admin/agencia/pedidos/criacao":
        if (widthScreen < 1456) {
          document.body.classList.remove('nav-actived');
        } else {
          document.body.classList.add('nav-actived');
        }
        break;
    
      case "/admin/agencia/pedidos/revisaoInterna":
        if (widthScreen < 1361) {
          document.body.classList.remove('nav-actived');
        } else {
          document.body.classList.add('nav-actived');
        }
        break;
      // case "/admin/agencia/pedidos/aprovacaoDeRedacao":
      //   if (widthScreen < 1357) {
      //     document.body.classList.remove('nav-actived');
      //   } else {
      //     document.body.classList.add('nav-actived');
      //   }
      //   break;
      case "/admin/agencia/pedidos/aprovacaoDeArte":
        if (widthScreen < 1357) {
          document.body.classList.remove('nav-actived');
        } else {
          document.body.classList.add('nav-actived');
        }
        break;
      case "/admin/agencia/pedidos/fechamentoDeArquivo":
        if (widthScreen < 1395) {
          document.body.classList.remove('nav-actived');
        } else {
          document.body.classList.add('nav-actived');
        }
        break;
      case "/admin/agencia/pedidos/finalizado":
        if (widthScreen < 1305) {
          document.body.classList.remove('nav-actived');
        } else {
          document.body.classList.add('nav-actived');
        }
        break;
      default:
        if (widthScreen < 1194) {
          document.body.classList.remove('nav-actived');
        } else {
          document.body.classList.add('nav-actived');
        }
    }
  };

  listenForResize = () => {
    window.addEventListener('resize', this.closeMenuOnSmallScreen);
    // window.onresize = ()  => {this.closeMenuOnSmallScreen;}
  };

  onSearchChange = (event) => {
    clearTimeout(this.searchTimeout);
    const { value } = event.target;
    const { groups, products } = this.state
    if (value) {
      const filterGroups = groups.filter(x => x.group.toLowerCase().includes(value));
      const filterProducts = products.filter(x => x.label.toLowerCase().includes(value));
      this.setState({
        filterGroups,
        filterProducts
      })
    }
    else {
      this.setState({
        filterGroups: [],
        filterProducts: []
      })
    }
  };

  render() {
    const { user, search, groups, filterGroups, products, filterProducts } = this.state;
    const { agencia, trade, comunicacao, cadastros: cadastroUsuario } = user || {};
    const cadastros = agencia || trade || comunicacao || cadastroUsuario;
    const { showAdminMenu, badgets } = this.props;
    const validate = true;
    const isDesigner = user && user.nivel ? user.nivel.id === Criacao : validate;
    const isConsulting = user && user.nivel ? user.nivel.id === GerenteComercial : validate;
    const isComunicacao = user && user.nivel ? user.nivel.id === Comunicacao : validate;
    const isTradeAdm = user && user.nivel ? user.nivel.id === TradeAdm : validate;

    const userRestrict = isConsulting || isDesigner ;

    return (
      <div
        className={`nav-wrapper${showAdminMenu ? ' nav-wrapper--admin' : ''}`}
      >
        {(user.nivel.id === Administrador || (isDesigner || isConsulting || isTradeAdm) || (comunicacao && isComunicacao))  && (
          <div
            className={`nav-toggle-wrapper${showAdminMenu ? ' nav-toggle-wrapper--actived' : ''
              }`}
          >
            <label htmlFor="nav-toggle">
              {showAdminMenu ? 'Administrador' : 'Loja'}
            </label>
            <ToggleSmall
              id="nav-toggle"
              className="nav-toggle"
              toggled={!showAdminMenu}
              onClick={() => this.toggleMenu()}
              ariaLabel="nav-toggle"
            />
          </div>
        )}


       
        {showAdminMenu && (
          
          <div>
            
            {(agencia || comunicacao || trade) && !isTradeAdm && !isComunicacao && (
              <div className="nav-items nav-border">
                <Accordion
                  headerComponent={isExpanded =>
                    this.renderHeaderComponent('Dashboard', isExpanded)
                  }
                  expanded={this.isCurrentRoute('/admin/dashboard')}
                >
                  <div className="nav-items-list">
                    {agencia && (<Link to="/admin/dashboard/agencia">Agência</Link>)}
                    {comunicacao && (<Link to="/admin/dashboard/comunicacao">Comunicação</Link>)}
                    {trade && (<Link to="/admin/dashboard/trade">Trade</Link>)}
                  </div>
                </Accordion>
              </div>
            )}

            {(isTradeAdm) &&
              (
              <div className="nav-items nav-border">
                <Accordion
                  headerComponent={isExpanded =>
                    this.renderHeaderComponent('Pedidos', isExpanded, ((badgets || {}).preCadastro), !!agencia)
                  }
                >
                  <div className="nav-items-list">
                    <Link to="/admin/agencia/pedidos" className="home">
                    Fluxo de pedidos
                    </Link>
                  </div>          
                </Accordion>

              </div>)}
            {(isComunicacao) &&
            (
            <div className="nav-items nav-border">
              <Accordion
                headerComponent={isExpanded =>
                  this.renderHeaderComponent('Pedidos', isExpanded, ((badgets || {}).preCadastro), !!agencia)
                }
              >
                <div className="nav-items-list">
                  <Link to="/admin/comunicacao/campanhas/todos" className="home">
                  Campanhas de Mensagens
                  </Link>
                </div>          
              </Accordion>

            </div>)}
           
            
            {(agencia || trade || comunicacao) && !isTradeAdm && !isComunicacao && (
              <div className="nav-items nav-border">
                <Accordion
                  headerComponent={isExpanded =>
                    this.renderHeaderComponent('Pedidos', isExpanded, ((badgets || {}).preCadastro), !!agencia)
                  }
                >
                  {agencia && (
                    <div>
                      <h4>Agência</h4>
                      <div className="nav-items-list badget-menu">
                        <Link to="/admin/pre-cadastros/pendentes">
                          Pré-Cadastro de
                          <br />
                          Unidades
                          {badgets && badgets.preCadastro > 0 && (<span className="badget" style={{ marginTop: "-10px" }}>{badgets.preCadastro}</span>)}
                        </Link>
                        <Link to="/admin/agencia/pedidos">Fluxo de Pedidos</Link>
                      </div>
                    </div>
                  )}
                  {comunicacao && (
                    <div>
                      <h4>Comunicação</h4>
                      <div className="nav-items-list">
                        <Link to="/admin/comunicacao/campanhas/todos" exact={false}>
                          Campanhas de Mensagens
                        </Link>
                      </div>
                    </div>
                  )}
                  {trade && (
                    <div>
                      <h4>trade</h4>
                      <div className="nav-items-list">
                        <Link to="/admin/trade/brindes/todos">Pedidos de Brinde</Link>
                        <Link to="/trade/admin/uniformes/lista/todos">
                          Pedidos de Uniforme
                        </Link>
                        <Link to="/trade/admin/pranchetas/lista/todos">
                          Pedidos de Prancheta
                        </Link>
                        <Link to="/trade/admin/campanhas-promocionais/lista/todos">
                          Campanhas Promocionais
                        </Link>
                      </div>
                    </div>
                  )}
                </Accordion>
              </div>
            )}
            {cadastros && !isTradeAdm && !isComunicacao && (
              <div className="nav-items nav-border">
                <Accordion
                  headerComponent={isExpanded =>
                    this.renderHeaderComponent('Cadastros', isExpanded, (badgets || {}).usuarios, !!cadastroUsuario)
                  }
                >
                  {(agencia) && (
                    <div className="nav-items-list bold-uppercase-item">
                      <Link to="/admin/produtos/1">Produtos</Link>
                    </div>
                  )}
                  {(agencia || trade) && (
                    <div className="nav-items">
                      <Accordion
                        headerComponent={isExpandedItem =>
                          this.renderItemHeaderComponent(
                            `CONFIGURAÇÕES DE PRODUTOS`,
                            isExpandedItem
                          )
                        }
                        expanded={this.isCurrentRoute('/trade/todos-brindes')}
                      >
                        {(agencia) && (
                          <div className="nav-items-list">
                            <Link to="/admin/aplicacoes/produtos">
                              Aplicações de Produtos
                            </Link>
                          </div>
                        )}
                        {trade && (
                          <div className="nav-items-list">
                            <Link to="/admin/categorias/produtos">
                              Categorias de Produtos
                            </Link>
                          </div>
                        )}
                        {(agencia) && (
                          <div className="nav-items-list">
                            <Link to="/admin/detalhes/produtos">
                              Detalhes de Produtos
                            </Link>
                          </div>
                        )}
                        {(trade || agencia) && (
                          <div className="nav-items-list">
                            <Link to="/admin/grupos/produtos">
                              Grupos de Produtos
                            </Link>
                          </div>
                        )}
                        {(agencia) && (
                          <React.Fragment>
                            <div className="nav-items-list">
                              <Link to="/admin/materiais/produtos">
                                Materiais de Produtos
                              </Link>
                            </div>
                            <div className="nav-items-list">
                              <Link to="/admin/nomes/produtos">Nomes de Produtos</Link>
                            </div>
                            <div className="nav-items-list">
                              <Link to="/admin/tamanhos/produtos">Tamanhos</Link>
                            </div>
                            <div className="nav-items-list">
                              <Link to="/admin/tags/produtos">Tags de Preço</Link>
                            </div>
                          </React.Fragment>
                        )}
                      </Accordion>
                    </div>
                  )}
                  {(agencia) && (
                    <div className="nav-items-list bold-uppercase-item">
                      <Link to="/admin/fornecedores">Fornecedores</Link>
                    </div>
                  )}
                  {(comunicacao) && (
                    <div>
                      <Accordion
                        headerComponent={isExpandedItem =>
                          this.renderItemHeaderComponent(
                            `MODELOS DE MENSAGENS`,
                            isExpandedItem
                          )
                        }
                        expanded={this.isCurrentRoute('/admin/modelos-mensagem/lista/mensagem')}
                      >
                        <div className="nav-items-list">
                          <Link to="/admin/modelos-mensagem/lista/mensagem">
                            Modelos
                          </Link>
                          <Link to="/admin/modelos-mensagem/categorias/mensagem">Categorias</Link>
                        </div>
                      </Accordion>
                    </div>
                  )}
                  {cadastroUsuario && (
                    <React.Fragment>
                      <div className="nav-items-list bold-uppercase-item badget-menu">
                        <Link to="/admin/usuarios/lista/novos">
                          Usuários
                          {badgets && badgets.usuarios > 0 && (<span className="badget">{badgets.usuarios}</span>)}
                        </Link>
                      </div>
                      <div className="nav-items-list bold-uppercase-item">
                        <Link to="/admin/Equipes/lista">Equipes</Link>
                      </div>
                    </React.Fragment>
                  )}
                  {(agencia && (
                    <div className="nav-items-list bold-uppercase-item">
                      <Link to="/admin/banner-dashboard">Banners Dashboard</Link>
                    </div>
                  ))}
                </Accordion>
              </div>
            )}
            {(user.nivel.id === Administrador ? trade : AGENCIA.loja) && !isTradeAdm && !isComunicacao && (
              <div className="nav-items nav-border">
                <Accordion
                  headerComponent={isExpanded =>
                    this.renderHeaderComponent('Gestão', isExpanded)
                  }
                >
                  <div className="nav-items-list">
                    <Link to="/admin/gestao/budgets">Budgets</Link>
                  </div>
                  <div className="nav-items-list">
                    <Link to="/admin/gestao/segmentos">Segmentos</Link>
                  </div>
                </Accordion>
              </div>
            )}
          </div>
        )}

        {!userRestrict &&
          !showAdminMenu && (
            <div>
              <Link to="/" className="home home-text">
                Início
              </Link>
              {(AGENCIA.loja) && (
                <div className="nav-items nav-border">
                  <Accordion
                    headerComponent={isExpanded =>
                      this.renderHeaderComponent('Agência', isExpanded)
                    }
                    expanded={this.isCurrentRoute('/agencia')}
                  >
                    <div className="nav-items-list">
                      <Link to="/agencia/pre-cadastro">
                        Pré-Cadastro de Unidades
                      </Link>
                      <Accordion
                        headerComponent={isExpandedItem =>
                          this.renderItemHeaderComponent(
                            `Produtos ${groups.length > 0 ? `(${groups.length})` : ''
                            }`,
                            isExpandedItem
                          )
                        }
                        expanded={false}
                      >
                        <Search
                          className="search-request-agency campoPedido some-class"
                          id="search-1"
                          name="busca"
                          value={search}
                          onChange={e => this.onSearchChange(e, 'search')}
                          labelText="Pesquisa Produto"
                          placeHolderText="Pesquisa Produto"
                        />
                        {filterGroups.length > 0 && (
                          filterGroups.map(group => (
                            filterProducts.filter(x => x.groupId === group.id).length === 1 ? (
                              <Link
                                key={group.id}
                                to={`/agencia/grupo/${group.id}`}
                              >
                                {group.group}
                              </Link>
                            ) : (
                              <Accordion
                                headerComponent={isExpandedItem =>
                                  this.renderItemHeaderComponent(
                                    `${group.group}`,
                                    isExpandedItem
                                  )}
                                expanded={false}
                              >
                                {filterProducts.map(product => (
                                  product.groupId === group.id ? (
                                    <Link
                                      key={product.id}
                                      to={`/agencia/grupo/${group.id}/${product.id}`}
                                    >
                                      {product.label}
                                    </Link>
                                  ) : ''
                                ))}
                              </Accordion>
                            )
                          )))}
                        {filterGroups.length === 0 && filterProducts.length > 0 && (
                          filterProducts.map(product => (
                            <Link
                              key={product.id}
                              to={`/agencia/grupo/${product.groupId}/${product.id}`}
                            >
                              {product.label}
                            </Link>
                          )))}
                        {filterGroups.length === 0 && filterProducts.length === 0 && (
                          groups.map(group => (
                            products.filter(x => x.groupId === group.id).length === 1 ? (
                              <Link
                                key={group.id}
                                to={`/agencia/grupo/${group.id}`}
                              >
                                {group.group}
                              </Link>
                            ) : (
                              <Accordion
                                headerComponent={isExpandedItem =>
                                  this.renderItemHeaderComponent(
                                    `${group.group}`,
                                    isExpandedItem
                                  )}
                                expanded={false}
                              >
                                {products.map(product => (
                                  product.groupId === group.id ? (
                                    <Link
                                      key={product.id}
                                      to={`/agencia/grupo/${group.id}/${product.id}`}
                                    >
                                      {product.label}
                                    </Link>
                                  ) : ''
                                ))}
                              </Accordion>
                            )
                          )))}
                      </Accordion>
                    </div>
                  </Accordion>
                </div>
              )}
              {(COMUNICACAO.loja) && (
                <div className="nav-items nav-border">
                  <Accordion
                    headerComponent={isExpanded =>
                      this.renderHeaderComponent('Comunicação', isExpanded)
                    }
                    expanded={this.isCurrentRoute('/comunicacao')}
                  >
                    <div className="nav-items-list bold-uppercase-item">
                      <Link to="/comunicacao/campanhas/criar">
                        Campanhas de Mensagens
                      </Link>
                    </div>
                  </Accordion>
                </div>
              )}
              {/* {(TRADE.loja) && (
                <div className="nav-items nav-border">
                  <Accordion
                    headerComponent={isExpanded =>
                      this.renderHeaderComponent('Trade', isExpanded)
                    }
                  >
                    <div className="nav-items-list">
                      <Accordion
                        headerComponent={isExpandedItem =>
                          this.renderItemHeaderComponent(
                            `Brindes ${categorias.length ? `(${categorias.length})` : ''
                            }`,
                            isExpandedItem
                          )
                        }
                        expanded={this.isCurrentRoute('/trade/todos-brindes')}
                      >
                        {categorias.map(categ => (
                          <Link
                            key={categ.id}
                            to={`/trade/brindes/categoria/${categ.id}`}
                          >
                            {categ.categoria}
                          </Link>
                        ))}
                      </Accordion>
                      <Link
                        className="bold-uppercase-item"
                        to="/trade/pranchetas"
                      >
                        Pranchetas
                      </Link>
                      <Link
                        className="bold-uppercase-item"
                        to="/trade/campanhas"
                      >
                        Campanhas Promocionais
                      </Link>
                    </div>
                  </Accordion>
                </div>
              )} */}
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showAdminMenu: state.main.showAdminMenu,
  badgets: state.main.badgets
});

const mapDispatchToProps = dispatch => ({
  toggleAdminMenu() {
    dispatch(mainActions.toggleAdminMenu());
  },
  loadBadgets() {
    return dispatch(mainActions.receiveBadget());
  },
});

const ConnectedNavigation = connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);
const NavigationWithRouter = withRouter(ConnectedNavigation);

export default NavigationWithRouter;



// WEBPACK FOOTER //
// ./src/components/Navigation.js